'use client';

import { useCallback, useMemo } from 'react';
import { FilterList, FilterListProps } from '@/components/Filters/FilterList';
import { ActiveListFilter, ListFacetsAndCategories } from '@/components/Filters/listFilter';
import { GetPathNameArgs } from '@/i18n/navigation';
import { getListPageSlugByFilter } from '@/utility/listPages';
import { Locale } from '@/utility/locale';
import { sanitizeQuery } from '@/utility/urls';

type CYOFilterListProps = Omit<FilterListProps, 'getPathnameArgs'> & {
  locale: Locale;
};
export const CYOFilterList = ({ locale, filter, activeFilter }: CYOFilterListProps) => {
  const currentSlug = useMemo(
    () => getListPageSlugByFilter(filter, activeFilter),
    [activeFilter, filter]
  );

  const getPathnameArgs = useCallback(
    (
      newFilter: Partial<ListFacetsAndCategories>,
      newActiveFilter: ActiveListFilter
    ): GetPathNameArgs => {
      const { department: newDepartment, category: newCategory, ...searchParams } = newActiveFilter;

      // Use existing slug if the department and category are the same (for better performance)
      const slug =
        newDepartment === activeFilter?.department && newCategory === activeFilter?.category
          ? currentSlug
          : getListPageSlugByFilter(newFilter, newActiveFilter);

      return {
        href: {
          pathname: '/cyo/assortment/list/[[...slug]]',
          params: { slug },
          query: sanitizeQuery(searchParams),
        },
        locale: locale,
      };
    },
    [activeFilter?.category, activeFilter?.department, currentSlug, locale]
  );

  return (
    <FilterList
      filter={filter}
      activeFilter={activeFilter}
      getPathnameArgs={getPathnameArgs}
      sortOptions={['weight', 'new', 'price', 'priceReverse']}
    />
  );
};
